{
  "actionbar.actions": "Действия",
  "actionbar.actionsAvailable": "Налични действия.",
  "actionbar.clearSelection": "Изчистване на избора",
  "actionbar.selected": "{count, plural, =0 {Няма избрани} one {# избран} other {# избрани}}",
  "actionbar.selectedAll": "Всички избрани",
  "actionbutton.pending": "недовършено",
  "breadcrumbs.more": "Още елементи",
  "button.pending": "недовършено",
  "calendar.invalidSelection": "{selectedCount, plural, one {Избраната дата не е налична} other {Избраните дати не са налични}}.",
  "combobox.loading": "Зареждане...",
  "combobox.loadingMore": "Зареждане на още...",
  "combobox.noResults": "Няма резултати",
  "contextualhelp.help": "Помощ",
  "contextualhelp.info": "Информация",
  "datepicker.endTime": "Краен час",
  "datepicker.startTime": "Начален час",
  "datepicker.time": "Време",
  "dialog.alert": "Сигнал",
  "dialog.dismiss": "Отхвърляне",
  "dropzone.replaceMessage": "Пуснете файл за замяна",
  "inlinealert.informative": "Информация",
  "inlinealert.negative": "Грешка",
  "inlinealert.notice": "Предупреждение",
  "inlinealert.positive": "Успешно",
  "label.(optional)": "(незадължително)",
  "label.(required)": "(задължително)",
  "listview.loading": "Зареждане...",
  "listview.loadingMore": "Зареждане на още...",
  "menu.loading": "Зареждане...",
  "menu.loadingMore": "Зареждане на още...",
  "menu.moreActions": "Повече действия",
  "menu.noResults": "Няма резултати",
  "menu.unavailable": "Недостъпно, разгънете за подробности",
  "notificationbadge.indicatorOnly": "Нова дейност",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Зареждане...",
  "picker.loadingMore": "Зареждане на още...",
  "picker.placeholder": "Изберете…",
  "picker.selectedCount": "{count, plural, =0 {Няма избрани елементи} one {# избран елемент} other {# избрани елемента}}",
  "sidepanel.collapse": "Сгъване на страничния панел",
  "sidepanel.expand": "Разгъване на страничния панел",
  "slider.maximum": "Максимум",
  "slider.minimum": "Минимум",
  "table.cancel": "Отказ",
  "table.drag": "Плъзнете",
  "table.editCell": "Редактиране на клетка",
  "table.loading": "Зареждане...",
  "table.loadingMore": "Зареждане на още...",
  "table.resizeColumn": "Преоразмеряване на колона",
  "table.save": "Запазване",
  "table.sortAscending": "Възходящо сортиране",
  "table.sortDescending": "Низходящо сортиране ",
  "tag.actions": "Действия",
  "tag.hideButtonLabel": "Показване на по-малко",
  "tag.noTags": "Нито един",
  "tag.showAllButtonLabel": "Показване на всички ({tagCount, number})",
  "toast.clearAll": "Изчисти всички",
  "toast.collapse": "Свиване",
  "toast.showAll": "Покажи всички",
  "treeview.loadingMore": "Зареждане на още..."
}
